<template>
    <time-parts-comp
        :value="timeParts"
        :seconds-left="secondsLeft"
    ></time-parts-comp>
</template>

<script setup lang="ts">
import { watch, ref } from "vue";
import TimePartsComp from "../../../commons/product/auction/countdown/time-parts.vue";
import { TimeDuration } from "@and3k5/timespan.js";
import { type TimeParts } from "../../../commons/product/auction/countdown/types";
import { getDateParts } from "../../../commons/product/auction/countdown";
import labels from "../../shared/labels";

const props = defineProps({
    secondsLeft: {
        type: Number,
        required: true,
    },
    blank: Boolean,
});

const duration = new TimeDuration(0);
const timeParts = ref<TimeParts>({
    days: {
        unit: "\u00a0",
        value: undefined,
    },
    hours: {
        unit: "\u00a0",
        value: undefined,
    },
    minutes: {
        unit: "\u00a0",
        value: undefined,
    },
    seconds: {
        unit: "\u00a0",
        value: undefined,
    },
});

watch(
    () => props.secondsLeft,
    (newValue) => {
        if (props.blank) return;
        if (newValue != null) {
            duration.setTotalSeconds(newValue);
            timeParts.value = getDateParts(duration, {
                ...labels.frontendProductList.productSpecs.time,
                minutes:
                    labels.frontendProductList.productSpecs.time.minutes.substring(
                        0,
                        3
                    ),
                seconds:
                    labels.frontendProductList.productSpecs.time.seconds.substring(
                        0,
                        3
                    ),
            });
        }
    },
    {
        immediate: true,
    }
);
</script>
